/**
 * Creates a Markdown-style hyperlink.
 * @param text - Text.
 * @param link - The URL to link to.
 * @returns A Markdown-formatted link string.
 */
export const createMarkDownLink = (text: string, link: string) => {
  return `[${text}](${link})`;
};
